import { Badge, BlockStack, Button, Card, Collapsible, DataTable, Divider, EmptyState, Grid, InlineStack, Text, Tooltip } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import shipping from '../../../../Asests/Images/shipping.png';
import customer from '../../../../Asests/Images/customer.png';
import styles from '../css/overview.module.css';
import { DI, DIProps } from '../../../../Core';
import NoResultsFound from "../../../../Asests/Images/NoResultsFound.png"
import { getDuration, getTargetCondition } from '../Utils/HelperFunc';
import { useTranslation } from 'react-i18next';

interface props extends DIProps { }

const Performance = (props: props) => {
    const { t } = useTranslation();
    const [myData, setMyData] = useState<any>({})
    const [expanded, setExpanded] = useState(false);
    const [rows, setRows] = useState<any>([
        [t('Negative Feedback'), t('N/A'), t('N/A'),],
        [t('A-Z Guarantee claims'), t('N/A'), t('N/A'),],
        [t('Chargeback claims'), t('N/A'), t('N/A'),],
    ]);

    useEffect(() => {
        props.di.POST("amazon/dashboard/getRating", {
            "user_id": props.redux.user_id,
            "target": {
                "marketplace": "amazon",
                "shop_id": props.redux.current.target._id
            }
        }).then((apiResponse: any) => {
            if (apiResponse?.success && apiResponse?.response?.length > 0) {
                setMyData({
                    ...myData,
                    orderDefectRate: apiResponse?.response?.[0]?.orderDefectRate,
                    validTrackingRate: apiResponse?.response?.[0]?.validTrackingRate
                });
                setRows([
                    [t('Negative Feedback'),
                    apiResponse?.response?.[0]?.orderDefectRate?.afn?.negativeFeedback?.count ?? t('N/A'),
                    apiResponse?.response?.[0]?.orderDefectRate?.mfn?.negativeFeedback?.count ?? t('N/A')],
                    [t('A-Z Guarantee claims'),
                    apiResponse?.response?.[0]?.orderDefectRate?.afn?.claims?.count ?? t('N/A'),
                    apiResponse?.response?.[0]?.orderDefectRate?.mfn?.claims?.count ?? t('N/A')],
                    [t('Chargeback claims'),
                    apiResponse?.response?.[0]?.orderDefectRate?.afn?.chargebacks?.count ?? t('N/A'),
                    apiResponse?.response?.[0]?.orderDefectRate?.mfn?.chargebacks?.count ?? t('N/A')],
                ]);
            }
        })
    }, []);

    const renderCustomerServicePerformance = () => {
        return (
            <div className={styles.Custom_Card__Background}>
                <BlockStack gap="300">
                    <Card background="bg-surface-secondary">
                        <InlineStack gap="400" blockAlign='start' wrap={false}>
                            <img src={customer} />
                            <BlockStack gap="300">
                                <Text variant="headingMd" as="h6" fontWeight="medium">{t("Customer Service Performance")}</Text>
                                <BlockStack gap="100">
                                    <div className={styles.Custom_tooltip_message}>
                                        <Tooltip dismissOnMouseOut content={t("Amazon Order Defect Rate (ODR) is a metric used by Amazon to measure the quality of customer service the sellers provide on the platform. It measures the percentage of orders returned due to a defect, such as a missing item, incorrect item, or damaged item.")}>
                                            <Text variant="bodySm" as="p" fontWeight="semibold">{t("ORDER DEFECT RATE (ODR)")}</Text>
                                        </Tooltip>
                                    </div>
                                    <Text variant="bodySm" as="p" fontWeight="semibold" tone="subdued">{`${t("Based on last")} ${getDuration(myData?.orderDefectRate?.afn)} ${t("days")}`}</Text>
                                    <InlineStack gap="100">
                                        <Text variant="bodySm" as="p" fontWeight="semibold">{t("Target:")}</Text>
                                        <Text variant="bodySm" as="p" fontWeight="semibold" tone="subdued">{t('< 1%')}</Text>
                                    </InlineStack>
                                </BlockStack>
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                            <BlockStack gap="400" align='center' inlineAlign='center'>
                                <Text variant="headingMd" as="h6" fontWeight="regular">{t("Seller Fulfilled")}</Text>
                                <BlockStack gap="500" align='center' inlineAlign='center'>
                                    <Text variant="headingXl" as="h4" fontWeight="medium">{getTargetCondition(myData?.orderDefectRate?.mfn?.targetCondition)} {myData?.orderDefectRate?.mfn?.targetValue}</Text>
                                    <Badge tone="success">{myData?.orderDefectRate?.mfn?.status}</Badge>
                                </BlockStack>
                            </BlockStack>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                            <BlockStack gap="400" align='center' inlineAlign='center'>
                                <Text variant="headingMd" as="h6" fontWeight="regular">{t("Fulfilled by Amazon")}</Text>
                                <BlockStack gap="500" align='center' inlineAlign='center'>
                                    <Text variant="headingXl" as="h4" fontWeight="medium">{getTargetCondition(myData?.orderDefectRate?.afn?.targetCondition)} {myData?.orderDefectRate?.afn?.targetValue}</Text>
                                    <Badge tone="success">{myData?.orderDefectRate?.afn?.status}</Badge>
                                </BlockStack>
                            </BlockStack>
                        </Grid.Cell>
                    </Grid>
                    <Collapsible
                        open={expanded}
                        id="basic-collapsible"
                        transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                        expandOnPrint
                    >
                        <DataTable columnContentTypes={['text', 'text', 'text']} headings={['', t('FBA'), t('FBM')]} rows={rows} />
                    </Collapsible>
                    <InlineStack align='end'>
                        <Button variant='plain' disclosure={expanded ? 'up' : 'down'} onClick={() => setExpanded(!expanded)} >
                            {expanded ? t('Hide Details') : t('Show Details')}
                        </Button>
                    </InlineStack>
                </BlockStack>
            </div>
        )
    }

    const renderShippingPerformance = () => {
        return (
            <div className={styles.Custom_Card__Background}>
                <BlockStack gap="300">
                    <Card background="bg-surface-secondary">
                        <InlineStack gap="400" blockAlign='start' wrap={false}>
                            <img src={shipping} />
                            <BlockStack gap="300">
                                <Text variant="headingMd" as="h6" fontWeight="medium">{t("Shipping Performance")}</Text>
                                <BlockStack gap="100">
                                    <Tooltip dismissOnMouseOut content={t("The Valid Tracking Rate (VTR) is all shipments with a valid tracking number as a percentage of total shipments during a given 30-day time period. VTR only applies to seller fulfilled orders.")}>
                                        <div className={styles.Custom_tooltip_message}>
                                            <Text variant="bodySm" as="p" fontWeight="semibold">{t("VALID TRACKING RATE")}</Text>
                                        </div>
                                    </Tooltip>
                                    <Text variant="bodySm" as="p" fontWeight="semibold" tone="subdued">{`${t("Based on last")} ${getDuration(myData?.validTrackingRate)} ${t("days")}`}</Text>
                                    <InlineStack gap="100">
                                        <Text variant="bodySm" as="p" fontWeight="semibold">{t("Target:")}</Text>
                                        <Text variant="bodySm" as="p" fontWeight="semibold" tone="subdued">{t(`> 95%`)}</Text>
                                    </InlineStack>
                                </BlockStack>
                            </BlockStack>
                        </InlineStack>
                    </Card>
                    <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                            <BlockStack gap="400" align='center' inlineAlign='center'>
                                <Text variant="headingMd" as="h6" fontWeight="regular">{t("Seller Fulfilled")}</Text>
                                <BlockStack gap="500" align='center' inlineAlign='center'>
                                    <Text variant="headingXl" as="h4" fontWeight="medium">{getTargetCondition(myData?.validTrackingRate?.targetCondition)} {myData?.validTrackingRate?.targetValue}</Text>
                                    <Badge tone="success">{myData?.validTrackingRate?.status}</Badge>
                                </BlockStack>
                            </BlockStack>
                        </Grid.Cell>
                    </Grid>
                </BlockStack>
            </div>
        )
    }
    return (
        <Card roundedAbove='sm'>
            {
                Object.keys(myData).length > 0 ?
                    <BlockStack gap="300">
                        <BlockStack gap="200">
                            <InlineStack wrap={false} gap="200" align='space-between'>
                                <Text variant="headingMd" as="h6">{t("Account Performance Metrices")}</Text>
                            </InlineStack>
                            <Divider />
                            <Text as="p" fontWeight="regular" tone="subdued">
                                {t("The Order Defect Rate (ODR) is a crucial metric that reflects the overall performance of a seller in terms of order-related issues and customer satisfaction.")}
                            </Text>
                        </BlockStack>
                        <BlockStack gap="300">
                            {renderCustomerServicePerformance()}
                            <Divider borderColor='border-hover' />
                            {renderShippingPerformance()}
                        </BlockStack>
                    </BlockStack>
                    :
                    <Card roundedAbove='sm'>
                        <div className='Custom__Empty--Result'>
                            <EmptyState image={NoResultsFound} heading={t("Performance metrics not found!")} />
                        </div>
                    </Card>
            }
        </Card>
    );
}

export default DI(Performance);